module.exports = __webpack_public_path__ + "img/logo.a9902b6e.png";